module.exports = __webpack_public_path__ + "static/img/injuryBody1.1586ca84.png";